// @ts-nocheck

import * as Types from '../../../../../../graphql/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { gql } from '@apollo/client';
export type EngagementsOpenChangeSetStatusQueryVariables = Types.Exact<{
  engagementIds:
    | Array<Types.InputMaybe<Types.Scalars['String']['input']>>
    | Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type EngagementsOpenChangeSetStatusQuery = {
  engagementsOpenChangeSetStatus: Array<{ engagementId?: string | null; hasOpenChangeSets: boolean } | null>;
};

export const EngagementsOpenChangeSetStatusDocument = gql`
    query EngagementsOpenChangeSetStatus($engagementIds: [String]!) {
  engagementsOpenChangeSetStatus(engagementIds: $engagementIds) {
    engagementId
    hasOpenChangeSets
  }
}
    ` as unknown as DocumentNode<EngagementsOpenChangeSetStatusQuery, EngagementsOpenChangeSetStatusQueryVariables>;
